export const US_MARKET = 'USA';
export const CA_MARKET = 'CA';

export const CA_GENERIC_EVENTS = ['eventTOR', 'eventMTL', 'eventVAN', 'eventEDM'];

export const INPUT_TYPE = {
  EMAIL: 'email',
  PHONE: 'phoneNumber',
  TOPIC_OF_INTEREST: 'topicOfInterest',
  FIRST_NAME: 'firstName',
  LAST_NAME: 'lastName',
  ZIP: 'zipCode',
  PREFERED_METHOD: 'preferredContactMethod',
  CONTACT_TIME: 'preferredContactTime',
  TRADE_IN_VEHICLE_MAKE: 'tradeInVehicleMake',
  TRADE_IN_VEHICLE_MODEL: 'tradeInVehicleModel',
  TRADE_IN_VEHICLE_YEAR: 'tradeInVehicleYear',
  TRADE_IN_VEHICLE_MILEAGE: 'tradeInVehicleMileage',
  TRADE_IN_VEHICLE_VIN: 'tradeInVehicleVin',
  MODEl_FAMILY_OF_INTEREST: 'modelFamilyOfInterest',
  MODEl_LINE_OF_INTEREST: 'modelLineOfInterest',
  DATE_PICKER: 'datePicker',
  TEST_DRIVE_BOOKING_TIME: 'preferedBookingTime',
  MODEL_LINES_SELECTED: 'modelLinesSelected',
  MODEl_LINE_SELECT_CUSTOM: 'modelLineSelectCustom',
  PURCHASE_TIME_FRAME: 'purchaseTimeFrame',
  PREFERRED_DEALER: 'preferredDealer',
  TIMING_HANDRAISER: 'timingHandraiser',
};

export const GROUPED_INPUTS = {
  CONTACT_INFORMATION: 'contactInformation',
  CONTACT_METHOD: 'contactMethod',
  TRADE_IN_VEHICLE: 'tradeInInputsGroup',
  MODEL_OF_INTEREST: 'modelOfInterestInputsGroup',
  TEST_DRIVE_BOOK: 'testDriveInputsGroup',
  BASIC_HANDRAISER: 'basicHandraiserGroup',
  MILITARY_INFORMATION: 'militaryInformation',
  SCHEDULE_SERVICE: 'scheduleServiceGroup',
};

export const FEATURE_APP_DETAILS = {
  baseUrl: `https://app-store.one.audi/details/a3deb048-3326-4dc5-848e-14efbaf14b5d`,
  id: 'a3deb048-3326-4dc5-848e-14efbaf14b5d',
  name: __FEATURE_APP_NAME__,
};

export const CAMPAIGN_ID = {
  genericContactDealer: 'AUCA_IB_DC_25_CADGENR_OP',
  vinSpecificContactDealer: 'AUCA_IB_DC_25_CADLVIN_OP',
  tradeInForm: 'AUCA_IB_DC_25_TRADEIN_OP',
};
